
import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');
template.innerHTML = `
<header-button 
    data-icon="fa fa-sign-in-alt"
    data-title="logIn"
    data-tooltip="openLogIn">
</header-button>
`;

export class HeaderLoginComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            location.href = window.location.origin + window.location.pathname + 'admin/login?redirect=../' + window.location.search + '&v=5'
        });
    }
}
